import React from "react";
import Header from "../components/Header";
import "../styles/homestyle.css";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";

const HomePage = () => {
  return (
    <>
      <div style={{ backgroundColor: "#34C3C9", height: "100vh" }}>
        <Header />
        <div className=" mt-lg-5">
          <div className=" d-flex flex-wrap justify-content-center  bookzip  ">
            <div>
              <img
                className="  mt-sm-3 w-100 bookwid "
                src={require("../pages/image/bookhome.png")}
                alt="logo"
              />
              <div
                className="text-center  mx-sm-5 mt-lg-4 mobil "
                style={{
                  color: "#FFFFFF",
                  fontFamily: "Open Sans",
                  fontWeight: "700",
                  lineHeight: "40px",
                  fontSize: "37px",
                  maxWidth: "391px",
                }}
              >
                Connect with people, share your passion
              </div>
            </div>

            <div
              className="mt-lg-5 align-items-center  "
              style={{ backgroundColor: "transparent" }}
            >
              <InputGroup
                className="cityzip  outline"
                style={{ backgroundColor: "transparent" }}
              >
                <Form.Control
                  className="px-3  placeholder-white mobilcitywid mobilwid111"
                  style={{
                    backgroundColor: "transparent",
                    width: "389px",
                    height: "55px",
                    fontFamily: "Open Sans",
                    fontWeight: "600",
                    lineHeight: "40px",
                    fontSize: "21px",
                    color: "#FFFFFF",
                  }}
                  placeholder="City or zip code"
                  aria-label="Recipient's username"
                  aria-describedby="basic-addon2"
                />
                <InputGroup.Text
                  className="mobil1"
                  id="basic-addon2"
                  style={{ width: "51px", height: "55px" }}
                >
                  <img
                    className=" sm:w-100  mobilwid "
                    src={require("../pages/image/searchbar.png")}
                    alt="logo"
                  />
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>
        </div>

        <div className="d-flex mt-5 gap-4 footerlink  ">
          <Link
            to="/terms"
            className="text-decoration-none fontmobil"
            style={{
              color: "#FFFFFF",
              fontFamily: "Open Sans",
              fontWeight: "700",
              lineHeight: "24.51px",
              fontSize: "18px",
            }}
          >
            Terms of use
          </Link>
          <Link
            to="/privacy"
            className="text-decoration-none fontmobil"
            style={{
              color: "#FFFFFF",
              fontFamily: "Open Sans",
              fontWeight: "700",
              lineHeight: "24.51px",
              fontSize: "18px",
            }}
          >
            Privacy
          </Link>
          <Link
            to="/cookies"
            className="text-decoration-none fontmobil"
            style={{
              color: "#FFFFFF",
              fontFamily: "Open Sans",
              fontWeight: "700",
              lineHeight: "24.51px",
              fontSize: "18px",
            }}
          >
            Cookies
          </Link>
        </div>
      </div>
    </>
  );
};

export default HomePage;
